import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Ng2FileInputModule } from 'ng2-file-input';

import { ReportsDataSourceComponent } from './reports/reports-data-source/reports-data-source.component';
import { ReportsStructureComponent } from './reports/reports-structure/reports-structure.component';
import { ReportsComponent } from './reports/reports.component';
import {
  ReportsStructureOperactionsComponent
} from './reports/reports-structure/reports-structure-operactions/reports-structure-operactions.component';
import {
  ReportsStructureDataComponent
} from './reports/reports-structure/reports-structure-data/reports-structure-data.component';
import { ManagementReportsComponent } from './management-reports.component';
import { SharedAdministrationModule } from '../shared-administration/shared-administration.module';
import { NotifierService } from '@app/shared/services/notifier.service';
import { ReportFilterComponent } from './reports/report-filter/report-filter.component';


@NgModule({
  imports: [
    CommonModule,
    SharedAdministrationModule,
    Ng2FileInputModule
  ],
  declarations: [
    ManagementReportsComponent,
    ReportsComponent,
    ReportsDataSourceComponent,
    ReportsStructureComponent,
    ReportsStructureOperactionsComponent,
    ReportsStructureDataComponent,
    ReportFilterComponent
  ],
  providers: [NotifierService]
})
export class ManagementReportsModule { }



// WEBPACK FOOTER //
// ./src/app/administration/management-reports/management-reports.module.ts